// @ts-nocheck
import React from 'react';
import emailjs from 'emailjs-com';
import { motion } from 'framer-motion';
import { init } from 'emailjs-com';
init('user_As8QFxjnACpfzbuAAYs4W');

export default function ContactForm({ closeModal }) {
  const modal_variant = {
    hidden: {
      y: '-10vw',
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.1,
        duration: 0.7,
        type: 'Spring',
      },
    },
  };

  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_wzkwscl',
        'template_kosh',
        e.target,
        'user_As8QFxjnACpfzbuAAYs4W'
      )
      .then(
        (result) => {
          closeModal();
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  return (
    <motion.div variants={modal_variant} initial='hidden' animate='visible'>
      <div className='contact__container'>
        <button className='contact__close-button' onClick={closeModal}>
          X
        </button>
        <h1 className='contact__title'>
          Contact <span>me</span>
        </h1>
        <form onSubmit={sendEmail}>
          <div className='row pt-5 mx-auto contact__row'>
            <div className='col-10 mx-auto pt-2 form-group contact__name'>
              <input
                type='text'
                size='29'
                className='contact__form-control'
                placeholder='Your name'
                name='name'
              />
            </div>
            <div className='col-10 pt-2 form-group mx-auto contact__email'>
              <input
                type='text'
                size='29'
                className='contact__form-control'
                placeholder='Your email'
                name='email'
              />
            </div>
            <div className='col-10 pt-2 form-group mx-auto contact__subject'>
              <input
                type='text'
                size='29'
                className='contact__form-control'
                placeholder='Subject'
                name='subject'
              />
            </div>
            <div className='col-10 pt-2 form-group mx-auto contact__message'>
              <textarea
                className='contact__form-control'
                id=''
                cols='30'
                rows='5'
                placeholder='Your message'
                name='message'
              />
            </div>
            <div className='col-10 pt-3 mx-auto'>
              <input
                type='submit'
                className='contact__form-button'
                value='Send message'
              />
            </div>
          </div>
        </form>
      </div>
    </motion.div>
  );
}
